import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {
  FC, useCallback, useEffect, useMemo, useState,
} from 'react';
import ReactSelect, { components, ValueType } from 'react-select';
import Typography from './Typography';
import { SelectOption } from '../../typings/select-option.typings';
import Label from './Label';
import { selectOptionDefault } from '../../components/SelectClassification';

interface Props {
  className?: string;
  disabled?: boolean;
  label?: string;
  name?: string;
  onChange?: (val: SelectOption) => void;
  options?: SelectOption[];
  placeholder?: string;
  value?: string;
  isClearable?: boolean;
}

const SingleSelect: FC<Props> = ({
  className,
  disabled,
  label,
  name,
  options = [],
  onChange,
  placeholder,
  value = '',
  isClearable = true,
}) => {
  const [state, setState] = useState(value);

  useEffect(() => {
    setState(value);
  }, [value]);

  const handleChange = useCallback((v: ValueType<SelectOption, false>) => {
    if (v === null || v === undefined) {
      setState('');
      if (onChange) {
        onChange({ value: '', label: '' });
      }
      return;
    }
    if (v.value) {
      setState(v.value);
    } else {
      setState('');
    }
    if (onChange) {
      if (v.value) {
        onChange(v);
      } else {
        onChange(selectOptionDefault);
      }
    }
  }, [onChange]);

  const finalValue = useMemo(() => {
    if (state) {
      const find = options.find((i) => i.value === state);

      if (find) {
        return find;
      }

      return {
        value: state,
        label: state,
      };
    }
    return null;
  }, [options, state]);

  const DropdownIndicator = useCallback((props) => {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon icon={faCaretDown} className="color-dark-gray" />
      </components.DropdownIndicator>
    );
  }, []);

  return (
    <>
      <Label>{label}</Label>
      <ReactSelect
        noOptionsMessage={(): string => 'Sem opções'}
        name={name}
        isClearable={isClearable}
        placeholder={<Typography>{placeholder}</Typography>}
        options={options}
        isDisabled={disabled}
        onChange={handleChange}
        value={finalValue}
        className={className}
        styles={{
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          control: (base): any => ({
            ...base,
            height: 48,
            borderRadius: 14,
          }),
        }}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        theme={(theme): any => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#5a67d8',
          },
        })}
        components={{
          IndicatorSeparator: null,
          DropdownIndicator,
        }}
      />
    </>
  );
};

export default SingleSelect;
